import React, { Dispatch, SetStateAction, isValidElement } from 'react';
import classnames from 'classnames';

import WpMenuItem from './WpMenuItem';

import { isElementOfType, sanitizeFragments } from '../../utilities/components';

import './WpMenu.scss';

type Dispatcher<S> = Dispatch<SetStateAction<S>>;
export type DirectionType = 'vertical' | 'horizontal';
const DEFAULT_DIRECTION_TYPE = 'vertical';

export interface Props {
  children?: React.ReactNode;
  onMenuItemClick?: Dispatcher<string>;
  activeItemId?: string;
  direction?: DirectionType;
}

const WpMenu: React.FC<Props> = ({
  children,
  onMenuItemClick,
  activeItemId,
  direction = DEFAULT_DIRECTION_TYPE,
}: Props) => {
  const handleItemClick = itemId => {
    if (onMenuItemClick) onMenuItemClick(itemId);
  };

  const sanitizedChildren = children && sanitizeFragments(children);
  const classNamePrefix = 'WpMenu';
  const classes = classnames(classNamePrefix, `${classNamePrefix}--${direction}`);

  return (
    <ul className={classes}>
      {React.Children.map(sanitizedChildren, (child: React.ReactElement<any>) => {
        const isValid = isValidElement(child);
        if (child && isElementOfType(child, WpMenuItem)) {
          return React.cloneElement(child, {
            activeItemId,
            onClick: onMenuItemClick ? handleItemClick : child.props?.onClick,
          });
        } else if (child && isElementOfType(child, WpMenu)) {
          return (
            <div className={`${classNamePrefix}--nested`}>
              {React.cloneElement(child, { activeItemId, onMenuItemClick })}{' '}
            </div>
          );
        } else if (isValid) {
          return React.cloneElement(child);
        } else return null;
      })}
    </ul>
  );
};

export default WpMenu;
